<div class="row">
    <div class="col-sm-8">
        <div class="form-group row">
            <label class="control-label col-md-4">Type de la commande :</label>
            <div class="col-md-8">
                <p>{{orderTypeLabel}}</p>
            </div>
        </div>
        <div class="form-group row">
            <label class="control-label col-md-4">Souhaitée pour :</label>
            <div class="col-md-8">
                <p>{{orderProg | date :"HH:mm"}}</p>
            </div>
        </div>
        <div class="form-group row">
            <label class="control-label col-md-4">Commentaire :</label>
            <div class="col-md-8">
                <textarea name="comment" [(ngModel)]="order.comment" class="form-control" rows="4"></textarea>
            </div>
        </div>
        <div class="form-group row" *ngIf="chosenOrderType==1">
            <label class="control-label col-md-4">Adresse:</label>
            <div class="col-md-8">
                <p>
                    <span>{{address.streetNumber}} {{address.streetName}} ( {{address.city}}
                        {{address.postalCode}})</span>
                </p>
            </div>
        </div>
        <div class="form-group row" *ngIf="chosenOrderType==1">
            <label class="control-label col-md-4">Compléments Adresse :</label>
            <div class="col-md-8 add-margin">
                <textarea placeholder="Batiment, Escalier, Etage, Porte, Code, Interphone ..."
                    [(ngModel)]="address.complementAddress" name="complementAddress" class="form-control"></textarea>
            </div>
        </div>
        <div class="form-group row" *ngIf="enablePayement">
            <label class="control-label col-md-4">Paiement sécurisé:</label>
            <div class="col-md-8 add-margin">
                <div class="list list-options">
                    <div class="list-item brdb pbxl">
                        <input id="Cod_ParCB" name="payamentmode" [(ngModel)]="payamentmode" class="osh-radio option"
                            type="radio" [value]="1">
                        <label class="fwm" for="Cod_ParCB">
                            <span class="-prm gradient-border" id="box">
                                <img src="assets/images/payement.jpg" alt="Paiement par carte bancaire">
                            </span>
                            Paiement par carte bancaire</label>
                        <div class="subtitle">
                            Priviligiez le paiement sans contact en payant en ligne avec votre carte bancaire, moyen
                            sécurisé et facile.
                        </div>
                    </div>
                    <div class="list-item brdb pbxl">
                        <input id="Cod_CashOnDelivery" name="payamentmode" [(ngModel)]="payamentmode"
                            class="osh-radio option" type="radio" [value]="2">
                        <label class="fwm" for="Cod_CashOnDelivery"><span class="-prm"><img
                                    src="assets/images/service-cash.png" alt=""></span>
                            Paiement à la livraison</label>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="payamentmode==2 && payementModes.length > 0" class="form-group row">
            <label class="control-label col-md-4">Mode de réglement :</label>
            <div class="col-md-8 payementModes">
                <div class="check-group" *ngFor="let pm of payementModes;let i=index">
                    <input type="checkbox" [(ngModel)]="pm.checked" [id]="'pm'+i">
                    <label [for]="'pm'+i">
                        {{pm.text}}
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <label class="control-label col-md-4">Vous avez un bon d'achat ?</label>
            <div class="col-md-8">
                <div class="input-group" [class.couponAdded]="couponAdded">
                    <input [disabled]="couponAdded" [(ngModel)]="coupon" type="text" style="padding: 10px!important;"
                        class="form-control" placeholder="Entrez ici votre coupon de réduction">
                    <span class="input-group-btn">
                        <button class="btn btn-default" *ngIf="!couponAdded" type="button" (click)="addCoupon()">Ajouter
                            le coupon</button>
                        <button class="btn btn-danger" *ngIf="couponAdded" type="button"
                            (click)="removeCoupon()">Retirer le coupon</button>
                    </span>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-offset-4 col-md-8">
                <div class="d-flex justify-content-between" *ngIf="order.discount>0">
                    <p>
                        <b>Sous-total :</b>
                    </p>
                    <div>
                        {{order.amount | number : '1.2-2'}}€
                    </div>
                </div>
                <div class="d-flex justify-content-between" *ngIf="order.discount>0">
                    <p>
                        <b>Remise {{order.discount}}% :</b>
                    </p>
                    <div>
                        {{-order.discountValue | number : '1.2-2'}}€
                    </div>
                </div>
                <div class="d-flex justify-content-between">
                    <p>
                        <b>Total TTC :</b>
                    </p>
                    <p>
                        <b>{{order.total | number : '1.2-2'}} €</b>
                    </p>
                </div>
                <div class="validate">
                    <button (click)="save()" [disabled]='loader'>
                        <i class="flaticon-tick"></i>
                        <ng-container *ngIf="loader">
                            <i class='glyphicon glyphicon-refresh spinning'></i>
                            &nbsp;&nbsp;
                        </ng-container>
                        <span>Confirmer la commande</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-4">
        <app-panier [showButton]="false" [updatePanier]="false"></app-panier>
    </div>
</div>